<template>
  <div class="row">
    <div class="col-xl-12 col-xs-12 vcenter" >
        <div class="form-middle-lookup">
            <div class="title-form" v-if="loader === '404'">
                <h2>Invalid URL</h2>
            </div>
            <div class="title-form" v-if="loader === 'false'">
                <h2>Your email has been confirmed</h2>
                <div class="bigger"> You may now begin using Orbitly </div>
                <router-link tag="button" class="btn btn-small m-t-40" :to="`/lookup?lookup=${lookup}`" v-if="lookup">
                  Start using Orbitly
                </router-link>
                <router-link tag="button" class="btn btn-small m-t-40" :to="`/`" v-if="!lookup">
                  Start using Orbitly
                </router-link>
            </div>
            <div v-if="loader === 'true'">
                <flash-message></flash-message>
                <div class="spinner">
                    <div class="double-bounce1"></div>
                    <div class="double-bounce2"></div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
  name: 'confirm_email',
  mounted () {
    this.$http.post('/api/user/validate_email_key', {
      confirm_email_key: this.$route.params.confirm_email_key }
    ).then((res) => {
      this.loader = 'false'
      this['user/setAuthUser'](res.data)
      if (res.data.lookup) {
        this.lookup = res.data.lookup
      }
    }).catch(() => {
      // console.log(err)
      this.loader = '404'
    })
  },
  data () {
    return {
      loader: 'true',
      lookup: false
    }
  },
  methods: {
    ...mapMutations([
      'user/setAuthUser'
    ])
  }
}
</script>
